"use client"

import {use, useState} from "react"
import {HeroSection} from "./hero-section"
import {ProcessSection} from "./process-section"
import {MotivationSection} from "./motivation-section"
import {ShareModal} from "./share-modal"
import type {InviteFriendsPageContent, ShareModalContent} from "../_api/content"
import {useAppContext} from "@/contexts/app-context";
import {PageBackground} from "@/components/sections/page-background";

interface InviteFriendsClientProps {
    contentPromise: Promise<InviteFriendsPageContent>
    shareContentPromise: Promise<ShareModalContent>
}

export function InviteFriendsClient({contentPromise, shareContentPromise}: InviteFriendsClientProps) {
    const [isShareModalOpen, setIsShareModalOpen] = useState(false)

    // Use the `use` hook to unwrap promises
    const content = use(contentPromise)
    const shareContent = use(shareContentPromise)

    const {user} = useAppContext()
    const linkPlaceholder = !user || !user.id ? `${process.env.NEXT_PUBLIC_DONISTA_WEB_URL}` : `${process.env.NEXT_PUBLIC_DONISTA_WEB_URL}/r/${user?.id}`

    return (
        <PageBackground>
            <main>
                <HeroSection {...content.hero} onShare={() => setIsShareModalOpen(true)}/>
                <ProcessSection {...content.process} />
                <MotivationSection {...content.motivation} />

                <ShareModal
                    isOpen={isShareModalOpen}
                    onClose={() => setIsShareModalOpen(false)}
                    {...shareContent}
                    linkPlaceholder={linkPlaceholder}
                    utmCampaign="25-08_friend-invitation" />
            </main>
        </PageBackground>
    )
}
